/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpCategoryShowCategoryResponse } from './CarpCategoryShowCategoryResponse';

export type CarpCategoryShowCategoryResponseApiRespoonse = {
    data?: CarpCategoryShowCategoryResponse;
    status?: CarpCategoryShowCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpCategoryShowCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

